export default [
    {
        path: '/date-mask-types',
        name: 'date-mask-types',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Tipos de Máscara de Datas',
            icon: 'mdi-calendar-heart',
            breadcrumbs: [
                { text: 'Lista de Tipos de Máscara de Datas', disabled: true }
            ]
        }
    }
]